var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCloudDrizzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.37 18.68c-.66.25-1.37-.23-1.37-.94v-1.32a3.53 3.53 0 0 0-3.53-3.53h-2.94A3.53 3.53 0 0 0 7 16.42V18c0 .55-.45 1-1 1h-.45C3.1 18.63 2 16.64 2 14.86c0-1.68.98-3.54 3.11-4.06-.59-2.33-.09-4.52 1.43-6.11 1.73-1.81 4.49-2.53 6.87-1.79 2.19.67 3.73 2.47 4.28 4.97 1.91.43 3.44 1.87 4.05 3.87.66 2.17.06 4.4-1.57 5.83-.53.49-1.14.86-1.8 1.11z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.53 14.39c-1.27 0-2.03.76-2.03 2.03v2.94c0 1.27.76 2.03 2.03 2.03h2.94c1.27 0 2.03-.76 2.03-2.03v-2.94c0-1.27-.76-2.03-2.03-2.03h-2.94zm-.06 5.68c-.09.09-.21.14-.32.14-.13 0-.24-.05-.33-.14a.459.459 0 0 1 0-.65l1.23-1.24a.47.47 0 0 1 .66 0c.18.18.18.48 0 .66l-1.24 1.23zm0-2.47c-.09.09-.21.14-.32.14a.47.47 0 0 1-.33-.8l1.23-1.23a.47.47 0 0 1 .66 0c.18.18.18.47 0 .65l-1.24 1.24zm2.48 2.47c-.1.09-.21.14-.33.14a.47.47 0 0 1-.33-.14.459.459 0 0 1 0-.65l1.24-1.24c.18-.18.47-.18.65 0 .18.18.18.48 0 .66l-1.23 1.23zm0-2.47c-.1.09-.21.14-.33.14a.47.47 0 0 1-.33-.8l1.24-1.23a.459.459 0 1 1 .65.65l-1.23 1.24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCloudDrizzle);
export default __webpack_public_path__ + "static/media/vuesax-bold-cloud-drizzle.9b39b46b5296db7768c26d042a7e1630.svg";
export { ForwardRef as ReactComponent };